export { default } from './CategoryNavDesktop';
